
define('text!widgets/preview/view.html',[],function () { return '<div class="gotomeet-preview-wrapper" data-bind="foreach: {data: settings.properties}">\n    <iframe id=\'profile-preview-frame\' data-bind="attr: {src: $data.personalUrl}"></iframe>\n</div>';});

